/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrOAuthApp } from './irrOAuthApp';
import { IrrConfigAuthIdentity } from './irrConfigAuthIdentity';
import { IrrSaasOAuthApp } from './irrSaasOAuthApp';


export interface IrrAuthorization { 
    identity?: IrrConfigAuthIdentity;
    uiTenant?: IrrOAuthApp;
    uiSupport?: IrrOAuthApp;
    vcds?: IrrSaasOAuthApp;
    vlcr?: IrrSaasOAuthApp;
}

